import { ref } from 'vue';
import { createGlobalState } from '@vueuse/core';
import type { IProjectInfo } from '@/types';

export const useGlobalState = createGlobalState(
    () => {
        const project = ref<IProjectInfo>();

        function updateProjectInfo(projectInfo: Partial<IProjectInfo>) {
            project.value = {
                ...project.value,
                ...projectInfo,
            }
        }

        return {
            project,
            updateProjectInfo,
        }
    }
)
